import React, { useEffect, useState } from "react";

export default function DealDetail({ date }) {
    const [deal, setDeal] = useState(null);

    useEffect(() => {
        fetch("/deals.json")
            .then((res) => res.json())
            .then((data) => {
                const found = data.find((d) => d.dateAdded === date);
                setDeal(found);
            })
            .catch((err) => console.error("Error loading deal:", err));
    }, [date]);

    if (!deal) {
        return (
            <main className="max-w-4xl mx-auto px-4 py-8">
                <p>Deal not found.</p>
            </main>
        );
    }

    return (
        <main className="max-w-4xl mx-auto px-4 py-8">
            <h2 className="text-3xl font-bold mb-4">{deal.title}</h2>
            <p className="text-lg text-slate-700">{deal.description}</p>
            <p className="text-sm text-slate-500 mt-4">
                Added {new Date(deal.dateAdded).toLocaleDateString()}
            </p>
            <img
                src={deal.image}
                alt={deal.title}
                className="w-full max-h-[600px] object-contain mb-6"
            />

            <a href="#/deals" className="inline-block mt-6 text-blue-600 underline">
                ← Back to all deals
            </a>
        </main>
    );
}
